import React, { useEffect, useState } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { ButtonSizeDLS, ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, TextAlignTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { Button } from "../../button/Button";
import ThemeProvider from "@voltmoney/theme";
import TooltipComp from "../TooltipComp";
import { isMobileView } from "../../stack/utils";
const PartnerLeadsRegistrationSuccess = ({ height, triggerAction, cancelAction, copyLinkAction, shareLinkAction, continueLoanApplicationAction, borrowerApplicationId, userFullName, shareLink, partnerInterestRate }) => {
    const theme = ThemeProvider.getTheme();
    const [sendOTPClicked, setSendOTPClicked] = useState(false);
    const [shareWithClient, setShareWithClient] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);
    const [copyLinkText, setCopyLinkText] = useState('');
    const isFromMobile = isMobileView();
    useEffect(() => {
        if (linkCopied) {
            setCopyLinkText('Link copied');
            setTimeout(() => {
                setLinkCopied(false);
            }, 2000);
        }
        else {
            setCopyLinkText('Copy link');
        }
    }, [linkCopied]);
    const shareTooltip = () => {
        return (React.createElement(TooltipComp, { width: 268, children: React.createElement(View, { style: { paddingHorizontal: -4, paddingBottom: 10 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2B, label: "Share loan application link" }),
                React.createElement(View, { style: { marginTop: 2 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3R, label: "Client can finish their loan application using this unique link." })),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        marginTop: 12,
                        height: 24,
                        justifyContent: 'center',
                        paddingBottom: 10
                    } },
                    React.createElement(View, { style: { width: 117, height: 24 } },
                        React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, typeDLS: ButtonTypeDLS.SECONDARY, sizeDLS: ButtonSizeDLS.SMALL, label: "Whatsapp", iconName: IconTokens.WHATSAPP_OUTLINE, iconAlignment: "right", customWidth: 90, height: 20, icon: { name: IconTokens.Whatsapp, size: IconSizeTokens.XS }, fontSize: FontSizeTokens.XS, onPress: () => {
                                triggerAction({
                                    ...shareLinkAction
                                });
                            } })),
                    React.createElement(View, { style: { marginLeft: 12, width: 111, height: 24 } },
                        React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: copyLinkText, typeDLS: ButtonTypeDLS.SECONDARY, iconName: IconTokens.Copy, iconAlignment: "right", customWidth: 80, height: 20, sizeDLS: ButtonSizeDLS.SMALL, icon: { name: IconTokens.Copy, size: IconSizeTokens.XS }, fontSize: FontSizeTokens.XS, onPress: () => {
                                setLinkCopied(true);
                                triggerAction({
                                    ...copyLinkAction,
                                });
                            } })))), tooltipArrowLeftPosition: isFromMobile ? 170 : 240, leftShiftContent: -130 }));
    };
    const bodyPart = () => {
        return (React.createElement(TouchableOpacity, { style: { height: height - 4 }, onPress: () => {
                setShareWithClient(false);
            }, activeOpacity: 1 },
            React.createElement(View, { style: {
                    height: 56,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    padding: 16,
                    alignItems: 'center',
                    alignContent: 'center'
                } },
                React.createElement(Typography, { label: "Customer registered", typeDLS: TypographyTypeDLS.H3B }),
                React.createElement(TouchableOpacity, { onPress: () => {
                        triggerAction({
                            ...cancelAction
                        });
                    }, hitSlop: { top: 24, bottom: 24, left: 24, right: 24 } },
                    React.createElement(Icon, { name: IconTokens.Cross, size: IconSizeTokens.XXXXL, color: ColorTokens.Grey_Charcoal }))),
            React.createElement(View, { style: {
                    height: 1,
                    backgroundColor: '#E4E7EC',
                } }),
            React.createElement(View, { style: { alignItems: 'center', alignContent: 'center', justifyContent: 'center', height: height - 176 } },
                React.createElement(Icon, { name: IconTokens.Success, size: IconSizeTokens.XXXXXXL }),
                React.createElement(View, { style: { marginTop: 24, alignContent: 'center', alignItems: 'center', paddingHorizontal: 16, width: '100%' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.H2B, label: "Customer registered successfully!", numberOfLines: 2, textAlign: TextAlignTokens.center }),
                    React.createElement(View, { style: {
                            paddingVertical: 8,
                            paddingHorizontal: 24,
                            marginTop: 16,
                            marginHorizontal: 16,
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexDirection: 'row',
                            borderRadius: 4,
                            backgroundColor: '#F3FAF6',
                            alignSelf: 'center',
                            width: '100%'
                        } },
                        React.createElement(Text, { style: { textAlign: 'center' } },
                            React.createElement(Text, { style: {
                                    fontWeight: '700',
                                    color: 'black',
                                    fontSize: 14,
                                    lineHeight: 20,
                                    textAlign: 'center'
                                } }, userFullName),
                            React.createElement(Text, { style: {
                                    fontWeight: '400',
                                    color: 'black',
                                    fontSize: 14,
                                    lineHeight: 20,
                                    textAlign: 'center'
                                } }, " has been linked to your account"))))),
            React.createElement(View, { style: { position: 'absolute', bottom: 0, width: '100%' } }, footerChild())));
    };
    const footerChild = () => {
        return (React.createElement(View, { style: { width: '100%' } },
            React.createElement(View, { style: {
                    width: '100%',
                    height: 1,
                    backgroundColor: '#E4E7EC',
                } }),
            React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16, paddingTop: 12 } },
                React.createElement(View, { style: { alignItems: 'center', alignContent: 'center', marginBottom: 12 } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: "Continue loan application", width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, height: 38, onPress: () => {
                            setSendOTPClicked(true);
                            triggerAction({
                                ...continueLoanApplicationAction,
                                payload: {
                                    value: borrowerApplicationId,
                                    userFullName: userFullName,
                                    shareLink: shareLink,
                                    partnerInterestRate: partnerInterestRate
                                }
                            });
                        } })),
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: "Share with client", iconName: IconTokens.ShareIcon, iconAlignment: "left", width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, icon: { name: IconTokens.Share, size: IconSizeTokens.MD }, height: 38, onPress: () => {
                        setShareWithClient(true);
                    } }),
                shareWithClient && shareTooltip())));
    };
    return (React.createElement(View, null, bodyPart()));
};
// @ts-ignore
export default (PartnerLeadsRegistrationSuccess);
